export default "__VITE_ASSET__BLqBe62Q__"